import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getInstallableModulesInfoForZone } from '../../../selectors/layout';
import { hasModuleTypeInstalled } from '../../../selectors/modules';
import { getProfileOwnerStats } from '../../../selectors/users';
import { Props } from './AddWidget';

type StateProps = Pick<
  Props,
  'hasCoreMembership' | 'hasSubmittedDeviations' | 'installableModulesInfo'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => {
  const stats = getProfileOwnerStats(state);

  return {
    hasCoreMembership: getCurrentUserHasCore(state),
    hasSubmittedDeviations: !!stats['deviations'] && stats['deviations'] > 0,
    hasCustomBoxInstalled: hasModuleTypeInstalled(state, 'papi_custombox'),
    installableModulesInfo: props.installableModules.map(module => {
      const modulesInfo = getInstallableModulesInfoForZone(
        state,
        props.section,
        module.zone
      );
      return {
        ...module,
        limit: 0,
        ...modulesInfo.find(
          moduleInfo => moduleInfo.moduleName === module.moduleName
        ),
      };
    }),
  };
};

export default connect(mapStateToProps);
